import React, { useState, useEffect } from 'react';
import { ArrowUp } from '@carbon/icons-react';
import './ScrollToTopButton.css';

const ScrollToTopButton = () => {
  const [show, setShow] = useState(false);

  // Find the element that is actually scrollable (has overflow + content).
  const getScrollable = () => {
    const selectors = [
      '.edit-sidebar__content',
      '.groups-container',
      '.page-container',
      '.cds--content'
    ];
    for (const sel of selectors) {
      const el = document.querySelector(sel);
      if (el && el.scrollHeight > el.clientHeight) return el;
    }
    return document.scrollingElement || document.documentElement;
  };

  useEffect(() => {
    const handleScroll = () => {
      const el = getScrollable();
      const top = el ? el.scrollTop : 0;
      setShow(top > 300);
    };

    // Capture-phase listener catches scroll events from any nested container.
    document.addEventListener('scroll', handleScroll, { passive: true, capture: true });
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Initial check in case the page loads already scrolled.
    handleScroll();

    return () => {
      document.removeEventListener('scroll', handleScroll, { capture: true });
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    const el = getScrollable();
    if (el) {
      el.scrollTo({ top: 0, behavior: 'smooth' });
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      className="scroll-to-top-button"
      onClick={scrollToTop}
      aria-label="Idi na vrh"
      style={{ opacity: show ? 1 : 0, pointerEvents: show ? 'auto' : 'none' }}
    >
      <ArrowUp size={20} />
    </button>
  );
};

export default ScrollToTopButton;
